import './scss/index.scss';
import { dcFactory } from 'dc';
import HeritageSearchFiltersComponent from './js/search-filters.component';

dcFactory.register(HeritageSearchFiltersComponent);
